// src/pages/Escala.jsx
import React, { useState, useEffect } from "react";
import { api } from "../../services/api.js";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer";
import Swal from "sweetalert2";
import "./escala.css";

function LoadingModal({ show, message }) {
  if (!show) return null;
  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-content">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <div style={{ marginTop: 15, fontSize: 18 }}>{message}</div>
      </div>
      <style>{`
        .loading-modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1050;
        }
        .loading-modal-content {
          background: white;
          padding: 20px 40px;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          box-shadow: 0 0 10px rgba(0,0,0,0.25);
        }
      `}</style>
    </div>
  );
}

function Escala() {
  const hoje = new Date();
  const mesAtual = String(hoje.getMonth() + 1).padStart(2, "0");
  const anoAtual = hoje.getFullYear();
  const [mesano, setMesAno] = useState(mesAtual + String(anoAtual));
  const [escala, setEscala] = useState([]);
  const [loading, setLoading] = useState(false);
  const chapa = localStorage.getItem("chapa");

  useEffect(() => {
    if (!chapa) return;
    carregarEscala();
  }, [mesano]);

  function carregarEscala() {
    setLoading(true);
    api
      .get(`/ponto/${chapa}/escala?mes=${mesano}`)
      .then((res) => {
        setLoading(false);
        if (!res.data || res.data.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "Nenhum dado encontrado",
            text: "Não foi encontrada escala para este período.",
          });
          setEscala([]);
        } else {
          setEscala(res.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro ao carregar",
          text: "Não foi possível carregar a escala.",
        });
        console.log(err);
      });
  }

  function handleMesAno(value) {
    setMesAno(value.substring(5, 7) + value.substring(0, 4));
  }

  function gerarDiasMes() {
    const mes = parseInt(mesano.substring(0, 2), 10) - 1;
    const ano = parseInt(mesano.substring(2), 10);
    const primeiroDia = new Date(ano, mes, 1);
    const ultimoDia = new Date(ano, mes + 1, 0);
    const dias = [];

    for (let i = 0; i < primeiroDia.getDay(); i++) {
      dias.push({ vazio: true });
    }

    for (let d = 1; d <= ultimoDia.getDate(); d++) {
      const dataStr = new Date(ano, mes, d).toISOString().split("T")[0];
      const info = escala.find((e) => e.data.startsWith(dataStr));
      dias.push({ dia: d, info });
    }

    while (dias.length % 7 !== 0) {
      dias.push({ vazio: true });
    }

    return dias;
  }

  const dias = gerarDiasMes();

  const horariosFixos = escala.filter((e) => e.tipo === "F");
  const horariosUnicos = [
    ...new Map(
      escala.filter((e) => e.tipo === "S").map((e) => [e.codigo, e])
    ).values(),
  ];
  const aniversario = escala.find((e) => e.tipo === "A");
  const ferias = escala.find((e) => e.tipo === "X");

  return (
    <div>
      <Menu modulo="ARBOR" />
      <div className="container-fluid pagina-ponto">
        <div className="col-xl-6 offset-xl-3">
          <label>Mês:</label>
          <input
            type="month"
            className="form-control"
            value={`${mesano.substring(2)}-${mesano.substring(0, 2)}`}
            onChange={(e) => handleMesAno(e.target.value)}
          />

          <table className="table table-bordered calendario">
            <thead>
              <tr>
                <th>dom</th>
                <th>seg</th>
                <th>ter</th>
                <th>qua</th>
                <th>qui</th>
                <th>sex</th>
                <th>sáb</th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: dias.length / 7 }, (_, i) => (
                <tr key={i}>
                  {dias.slice(i * 7, i * 7 + 7).map((d, j) => {
                    if (d.vazio) return <td key={j} className="vazio"></td>;
                    const { dia, info } = d;
                    let classe = "normal";
                    let extra = "";

                    if (info) {
                      switch (info.tipo) {
                        case "F":
                          classe = "descanso";
                          break;
                        case "A":
                          classe = "aniversario";
                          break;
                        case "S":
                          classe = "substituto";
                          extra = info.codigo;
                          break;
                        case "X":
                          classe = "ferias";
                          break;
                        default:
                          classe = "normal";
                      }
                    }

                    if (!info && horariosFixos.length > 0) {
                      extra = horariosFixos[0].codigo;
                    }

                    return (
                      <td key={j} className={classe}>
                        <div className="dia">{dia}</div>
                        {extra && <div className="codigo">{extra}</div>}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>

          <div className="legenda">
            <ul>
              {horariosFixos.length > 0 && (
                <li>
                  Trabalho: {horariosFixos[0].codigo} - {horariosFixos[0].descricao}
                </li>
              )}
              {horariosUnicos.map((h) => (
                <li key={h.codigo}>
                  Substituto: {h.codigo} - {h.descricao}
                </li>
              ))}
              {aniversario && <li>🎂 Seu aniversário</li>}
              {ferias && <li>🏖️ Suas férias</li>}
            </ul>
          </div>
        </div>
      </div>
      <Footer />
      <LoadingModal show={loading} message="Carregando escala..." />
    </div>
  );
}

export default Escala;
